import React, { useState, useMemo } from "react";
import { Proposal } from "./Proposal.jsx";
import PaginationComponent from "./Pagination/PaginationComponent.jsx";

export function ProposalList({
  proposals,
  configuration,
}) {
  let PageSize = 4;
  const [currentPage, setCurrentPage] = useState(1);

  const currentPageData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return proposals.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, proposals]);


  return (
    <>
      <div className="grid">
        {currentPageData.map((proposal) => (
          <Proposal
            key={proposal.pk}
            proposal={proposal}
            configuration={configuration}
          />
        ))}
      </div>
      <PaginationComponent
        className="w-100 p-2 mt-2 d-flex align-items-center justify-content-center"
        currentPage={currentPage}
        totalCount={proposals.length}
        pageSize={PageSize}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );
}
